import React from 'react'
import { Text, View, Image, StyleSheet } from '@react-pdf/renderer'
import { Style } from '@react-pdf/stylesheet'
import { useTranslation } from 'react-i18next'

import * as theme from 'src/parser/shared/PDF/theme'
import NoContent from 'src/parser/shared/PDF/NoContent'
import { TSectionContent } from 'src/parser/shared/PDF/Sections'

import {
  commonStyles,
  createDirectionalStyles,
} from 'src/parser/shared/PDF/Title/CommonUtils'

const Location: TSectionContent = ({ entity, map }) => {
  const { latitude, longitude, geofence } = entity.location ?? {}

  const { t, i18n } = useTranslation()
  const directionalStyles = createDirectionalStyles(commonStyles, i18n.language)

  if (typeof latitude !== 'number' || typeof longitude !== 'number')
    return <NoContent />

  return (
    <>
      {typeof geofence === 'object' && geofence !== null && (
        <LabelValuePair
          style={styles.geofenceContainer}
          label={t('alarm_report.location.geofence')}
          value={geofence.name}
        />
      )}
      <View style={[directionalStyles.container, styles.lngLatContainer]}>
        <LabelValuePair
          label={t('alarm_report.location.latitude')}
          value={t('alarm_report.location.lat_lng_format', {
            value: latitude,
          })}
        />
        <LabelValuePair
          label={t('alarm_report.location.longitude')}
          value={t('alarm_report.location.lat_lng_format', {
            value: longitude,
          })}
        />
      </View>
      {map != null && (
        <Image
          source={map}
          style={styles.map}
        />
      )}
    </>
  )
}

function LabelValuePair({
  label,
  value,
  style: styleProp,
}: {
  label: string
  value: string
  style?: Style | Style[]
}): JSX.Element {
  const { t, i18n } = useTranslation()
  const directionalStyles = createDirectionalStyles(commonStyles, i18n.language)
  const style: Style[] = [
    directionalStyles.container,
    ...(Array.isArray(styleProp) ? styleProp : [styleProp ?? {}]),
  ]

  return (
    <View style={style}>
      <Text style={[theme.styles.subtitle, directionalStyles.text]}>
        {label}
      </Text>
      <Text
        style={[
          theme.styles.subtitle,
          directionalStyles.text,
          styles.kvDelimiter,
        ]}
      >
        {t('global.kvSeparator')}
      </Text>
      <Text style={[theme.styles.text, directionalStyles.text]}>{value}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  geofenceContainer: {
    marginBottom: theme.spacing(1 / 4),
  },
  lngLatContainer: {
    columnGap: theme.spaceWidth.text,
  },
  kvDelimiter: {
    paddingHorizontal: theme.spaceWidth.text,
  },
  map: {
    width: '100%',
    alignSelf: 'center',
    marginTop: theme.padding(1),
  },
})

export default Location
